<div [ngClass]="{'dettaglio-date-container-acl': acl == 'eell'}" class="dettaglio-date-container">

    <h1 class="colorSearch" mat-dialog-title>DETTAGLIO DATE {{this.nomeEvento}}</h1>
    <div mat-dialog-content>  
            <mat-table [dataSource]="dataSource" matSort matSortActive="descrizione" matSortDirection="asc"  matSortDisableClear>

              <ng-container matColumnDef="enteAssociato">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Ente Associato </mat-header-cell>
                <mat-cell [attr.data-label]="'enteAssociato'" *matCellDef="let element">
                  {{element.enteAssociato}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="descrizione">
                <mat-header-cell *matHeaderCellDef mat-sort-header 
                                 [ngClass]="{'mat-column-descrizione-acl': acl == 'eell'}" 
                                 class="mat-column-descrizione"> Descrizione </mat-header-cell>
                <mat-cell [attr.data-label]="'DESCRIZIONE'" *matCellDef="let element" 
                          [ngClass]="{'mat-column-descrizione-acl': acl == 'eell'}" 
                          class="mat-column-descrizione"> {{element.descrizione}} </mat-cell>
              </ng-container>              
              
              <ng-container matColumnDef="dataChiusuraRaccoltaDati">
                <mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="{'mat-column-dataChiusuraRaccoltaDati-acl': acl == 'eell'}" class="mat-column-dataChiusuraRaccoltaDati"> Data Chiusura Raccolta Dati </mat-header-cell>
                <mat-cell [attr.data-label]="'dataChiusuraRaccoltaDati'" *matCellDef="let element" [ngClass]="{'mat-column-dataChiusuraRaccoltaDati-acl': acl == 'eell'}" class="mat-column-dataChiusuraRaccoltaDati">
                   {{this.datePipe.transform(element.dataChiusuraRaccoltaDati, 'dd/MM/yyyy')}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="dataChiusuraCorrezioneDati">
                <mat-header-cell *matHeaderCellDef mat-sort-header 
                                 [ngClass]="{'mat-column-dataChiusuraCorrezioneDati-acl': acl == 'eell'}" 
                                 class="mat-column-dataChiusuraCorrezioneDati"> Data Chiusura Correzione Dati </mat-header-cell>
                <mat-cell [attr.data-label]="'dataChiusuraCorrezioneDati'" *matCellDef="let element" 
                          [ngClass]="{'mat-column-dataChiusuraCorrezioneDati-acl': acl == 'eell'}" 
                          class="mat-column-dataChiusuraCorrezioneDati">
                  {{this.datePipe.transform(element.dataChiusuraCorrezioneDati, 'dd/MM/yyyy')}} </mat-cell>
              </ng-container>             
              
                <mat-header-row *matHeaderRowDef="displayedColumns "></mat-header-row>
                <mat-row *matRowDef="let row; columns:displayedColumns"></mat-row>
                
                
            </mat-table>

            <div *ngIf="this.dataSource.counter$.source['value'] === 0">
              <mat-card class="emptyTable">
                <mat-card-content>
                  <h6>Non ci sono risultati</h6>
                </mat-card-content>
              </mat-card>
            </div>

            <mat-paginator style="flex-wrap: wrap;" id='paginator' [pageSize]="risultatiPerPagina"
        [pageSizeOptions]="[3, 5, 10]"></mat-paginator>

    </div>

    <mat-dialog-actions align="end">
      <button mat-stroked-button color='accent' class='persBtn' mat-dialog-close>
        <p class='cont'>CHIUDI</p>
      </button>
    </mat-dialog-actions>
  
</div>
  